import { Button, Heading, Text, VStack } from '@chakra-ui/react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { add_to_wishlist } from '../../redux/actions/wishActions';
import toast from 'react-hot-toast';

const ImportModal = ({ isModalOpen, closeModal, item }) => {
    const dispatch = useDispatch();

    const addToWishlist = () => {
        toast.promise(
            dispatch(add_to_wishlist(item)),
            {
                loading: 'Adding...',
                success: <b> Pushed to wishlist</b>,
                error: <b>Could not add item.</b>,
            },
            { position: 'top-right' },
        );
    };

    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={() => closeModal()}
            className="Modal"
            overlayClassName="Overlay">
            <Container>
                <Heading as="h4" textAlign="center" fontSize="24px" mt="25px">
                    Product Added to WishList{' '}
                </Heading>
                <Text fontSize="16px" textAlign="center" mt="25px">
                    The Product has been imported successfully.{' '}
                </Text>
                <VStack mt="20px">
                    <Button
                        w="100%"
                        color="#F5F5F5"
                        bg="#1b3b5f"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        h="48px"
                        outline="none"
                        onClick={() => {
                            closeModal();
                            addToWishlist();
                        }}>
                        Push to WishList
                    </Button>
                    <Button
                        w="100%"
                        color="#202325"
                        bg="white"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        outline="none"
                        onClick={() => {
                            closeModal();
                        }}>
                        Cancel
                    </Button>
                </VStack>
            </Container>
        </Modal>
    );
};

export default ImportModal;

const Container = styled.div`
    width: 380px;
    max-height: 100%;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    padding: 24px 24px;
    padding-bottom: 50px;

    @media screen and (max-width: 500px) {
        padding: 18px 18px;
        width: 100vw;
        max-height: 100%;
        background: #ffffff;
        border-radius: 16px 16px 0px 0px;
    }
    a {
        width: 95%;
        border-radius: 5px;
        padding: 4px;
        height: 44px;
        font-size: 20px;
    }
    .active-link {
        background: rgba(33, 33, 241, 0.1);
        color: #1b3b5f;
        font-weight: 700;
        svg {
            path {
                stroke: #1b3b5f;
            }
        }
    }
`;
